
export enum AsyncComponentProductModelEnum {
    ProductModelMutate = 'ProductModelMutate',
    ProductModelTabs = 'ProductModelTabs',
    ProductModelListForm = 'ProductModelListForm',
    ProductModelMutateForm = 'ProductModelMutateForm',
    ProductModelList = 'ProductModelList',
    ProductModelSelector = 'ProductModelSelector',
    ProductModelManage = 'ProductModelManage',
    ProductModelOptional = 'ProductModelOptional',
    ProductModelColorSelector = 'ProductModelColorSelector'
}

export const productModelComponents = {
    [ AsyncComponentProductModelEnum.ProductModelMutate ]: () => import( '@/views/product/productModelMutate/ProductModelMutate.vue' ),
    [ AsyncComponentProductModelEnum.ProductModelTabs ]: () => import( '@/components/productModel/ProductModelTabs.vue' ),
    [ AsyncComponentProductModelEnum.ProductModelListForm ]: () => import( '@/components/productModel/ProductModelListForm.vue' ),
    [ AsyncComponentProductModelEnum.ProductModelList ]: () => import( '@/views/product/productModelList/ProductModelList.vue' ),
    [ AsyncComponentProductModelEnum.ProductModelMutateForm ]: () => import( '@/components/productModel/ProductModelMutateForm.vue' ),
    [ AsyncComponentProductModelEnum.ProductModelSelector ]: () => import( '@/components/productModel/ProductModelSelector.vue' ),
    [ AsyncComponentProductModelEnum.ProductModelManage ]: () => import( '@/components/productModel/ProductModelManage.vue' ),
    [ AsyncComponentProductModelEnum.ProductModelOptional ]: () => import( '@/components/productModel/ProductModelOptional.vue' ),
    [ AsyncComponentProductModelEnum.ProductModelColorSelector ]: () => import( '@/components/productModel/ProductModelColorSelector.vue' ),
}
